import { ref, set, onValue } from "firebase/database";
import { signOut } from "firebase/auth";
import { database, auth } from "../firebase/firebase";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminMenu from "../components/AdminMenu";

export default function AdminDashboard(){

const [status,setStatus] = useState(true)
const navigate = useNavigate()

useEffect(()=>{

const statusRef = ref(database,"system/settings/websiteActive")

onValue(statusRef,(snapshot)=>{
setStatus(snapshot.val())
})

},[])

const toggleWebsite = () =>{

set(ref(database,"system/settings/websiteActive"),!status)

}

const logout = async () => {

await signOut(auth)

navigate("/login")

}

return(

<div>

<AdminMenu/>

<div className="container">

<h2>Admin Dashboard</h2>

<div className="card">

<p>Website Status: {status ? "Running" : "Stopped"}</p>

<button onClick={toggleWebsite}>
{status ? "Stop Website" : "Start Website"}
</button>

</div>

<div className="card">

<button
onClick={logout}
style={{
background:"red",
marginTop:"10px"
}}
>
Logout
</button>

</div>

</div>

</div>

)

}